"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedPreviewFileTypes = exports.FETCHED = exports.FETCHING = exports.CANCELED = exports.ERRORS = exports.FAILED = exports.UPLOADED = exports.UPLOADING = exports.STANDBY = exports.DEFINED = exports.MISSING = exports.Lib = exports.Reducer = void 0;
exports.extractReturnType = extractReturnType;
var Lib = require("@caddigital/sok-types");
exports.Lib = Lib;
var Reducer = require("@caddigital/sok-reducers/lib/types");
exports.Reducer = Reducer;
exports.MISSING = 'MISSING';
exports.DEFINED = 'DEFINED';
exports.STANDBY = 'STANDBY';
exports.UPLOADING = 'UPLOADING';
exports.UPLOADED = 'UPLOADED';
exports.FAILED = 'FAILED';
exports.ERRORS = 'ERRORS';
exports.CANCELED = 'CANCELED';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
/**
 * @deprecated use ReturnType\<typedef function_name\>
 */
function extractReturnType(fn) {
    var typeExtractable = false && fn({});
    return typeExtractable;
}
exports.allowedPreviewFileTypes = [
    'PDF',
    'IMAGE',
    'VIDEO',
    'DWG',
    'SPREADSHEET',
    'TEXT',
    'OTHER',
    'PRESENTATION',
    'IFC'
];
